// src/routes.ts
import { BarChart2, Monitor, Film, List, MapPin, Calendar, Settings as SettingsIcon, Users } from 'lucide-react';
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import Assets from './pages/Assets';
import Playlists from './pages/Playlists';
import Locations from './pages/Locations';
import Schedules from './pages/Schedules';
import Settings from './pages/Settings';
import Audience from './pages/Audience';
import { ComponentType } from 'react';

export interface Route {
  path: string;
  name: string;
  component: ComponentType<any>;
  icon: ComponentType<any>; // Simple and works with all icon libraries
}

export const routes: Route[] = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    icon: BarChart2
  },
  {
    path: '/devices',
    name: 'Devices',
    component: Devices,
    icon: Monitor
  },
  {
    path: '/assets',
    name: 'Assets',
    component: Assets,
    icon: Film
  },
  {
    path: '/playlists',
    name: 'Playlists',
    component: Playlists,
    icon: List
  },
  {
    path: '/locations',
    name: 'Locations',
    component: Locations,
    icon: MapPin
  },
  {
    path: '/schedules',
    name: 'Schedules',
    component: Schedules,
    icon: Calendar
  },
  {
    path: '/audience',
    name: 'Audience',
    component: Audience,
    icon: Users
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    icon: SettingsIcon
  }
];